import React, {useEffect, useState} from "react";
// import Jitsi from "react-jitsi";
import Jitsi from "../../jitsi";
import {useHistory, Link, NavLink} from 'react-router-dom';
import {useParams} from 'react-router';
import axios from '../../config/axios-interceptor';
import {useSelector, useDispatch} from 'react-redux';
import {user} from "../../store/actions/auth.actions";

export default function App() {
  return (
    <div>
      <JedaiVideoConfig/>
    </div>
  );
}

const interfaceConfig = {
  TOOLBAR_BUTTONS: [
    'microphone', 'camera', 'desktop', 'fullscreen', 'hangup', 'profile', 'chat', 'sharedvideo',
    'settings', 'raisehand', 'videoquality', 'filmstrip', 'tileview'
  ]
};

const interfaceConfigCompany = [
  'microphone', 'camera', 'desktop', 'fullscreen',
  'hangup', 'profile', 'chat', 'sharedvideo', 'settings', 'raisehand',
  'videoquality', 'filmstrip', 'tileview', 'mute-everyone'
];

const JedaiVideoConfig = () => {
  const params: any = useParams();

  const [height, setHeight] = useState(window.innerHeight);

  const updateDimensions = () => {
    setHeight(window.innerHeight);
  }

  const dispatch = useDispatch();
  const auth_user = useSelector((state) => state.auth.user);

  useEffect(() => {
    dispatch(user());
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const handleAPI = JitsiMeetAPI => {
    JitsiMeetAPI.executeCommand("toggleVideo");
  };

  const config = auth_user && auth_user.isVisitor ? interfaceConfig : interfaceConfigCompany;

  return (
    auth_user && <Jitsi
      domain="b2b.vidict.live"
      onAPILoad={handleAPI}
      roomName={params.url}
      displayName={auth_user.fullName ? auth_user.fullName : 'user'}
      userInfo={{
        email: auth_user.email ? auth_user.email : '', //<email of the participant ex.'nikolovska.anastasija@gmail.com'>
      }}
      containerStyle={{width: '100%', height: height}}
      // @ts-ignore
      interfaceConfig={config}
      config={{
        disableDeepLinking: true,
        // @ts-ignore
        prejoinPageEnabled: false
      }}
    />
  );
};


